import { all, takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import { Types, recaptchaFailure, setSiteKey } from './actions';
import axios from '~/config/axios';
import commonApi from '~/helpers/api/common';

export function* recaptcha() {
  try {
    // @ts-ignore
    const siteKey = yield call(commonApi.getReCaptchaKey);
    yield put(setSiteKey(siteKey?.result?.secretKey));
  } catch (error) {
    yield put(recaptchaFailure(error));
  }
}
// @ts-ignore
export function setRecaptchaSuccessToken({ payload }) {
  axios.defaults.headers.common.documentId = payload;
}

export default all([
  takeLatest(Types.REQUEST, recaptcha),
  // @ts-ignore
  takeEvery(Types.SUCCESS_KEY, setRecaptchaSuccessToken),
]);
